import { render } from "./Attachment.vue?vue&type=template&id=76c1d61e&scoped=true"
import script from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Attachment.vue?vue&type=script&charset=utf-8&lang=js"

import "./Attachment.vue?vue&type=style&index=0&id=76c1d61e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c1d61e"]])

export default __exports__